var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, ErrorBoundary, FlexBox, Modal, ModalBody, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect } from 'react';
import { analyticsApi, } from 'apis/analytics';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAnalyticsState } from '../../../../utils/useAnalyticsState/useAnalyticsState';
import { usePersistInstrumentSettings } from '../../utils/usePersistInstrumentSettings';
import { InstrumentPanelTitle } from '../panel/components/title/instrumentPanelTitle';
import { InstrumentRendererError } from '../renderer/components/error/instrumentRendererError';
import { InstrumentRenderer } from '../renderer/instrumentRenderer';
import styles from './instrumentModal.module.scss';
export const InstrumentModal = ({ panel, onClose, }) => {
    const dispatch = useAppDispatch();
    const { context, period, filters, settings } = useAnalyticsState();
    const { instrumentSettings, setInstrumentSettings } = usePersistInstrumentSettings();
    const [readInstrumentsQuery, { instruments, isFetching, isError }] = analyticsApi.useLazyReadInstrumentsQuery({
        selectFromResult: (_a) => {
            var _b;
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { instruments: (_b = data === null || data === void 0 ? void 0 : data.data.instruments) !== null && _b !== void 0 ? _b : [] }));
        },
    });
    const readInstruments = useCallback((arg) => readInstrumentsQuery({
        id: panel.id,
        context,
        period,
        filters,
        settings: Object.assign(Object.assign({}, settings), instrumentSettings),
        meta: Object.assign(Object.assign({}, arg === null || arg === void 0 ? void 0 : arg.meta), { in_depth: true }),
    }).unwrap(), [
        context,
        filters,
        instrumentSettings,
        panel.id,
        period,
        readInstrumentsQuery,
        settings,
    ]);
    /**
     * Fetches the in-depth instrument data:
     *
     * - On initial component mount.
     * -
     * - When the `instrumentSettings` change. This happens when the user changes a
     *   setting specific to an instrument, such as chart granularity.
     */
    useEffect(() => {
        readInstruments();
        // Only run this effect when the relevant data points that should trigger an API request change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [instrumentSettings]);
    const handleExport = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'analytics:export',
                arg: {
                    instruments,
                    panel,
                },
            },
        }));
    };
    return (_jsxs(Modal, Object.assign({ className: styles.modal, isOpen: true, onClose: onClose }, { children: [_jsx(ModalHead, { title: _jsxs(FlexBox, Object.assign({ gap: "200", "data-analytics-panel": panel.id }, { children: [_jsx(Badge, Object.assign({ variant: "primary", size: "medium" }, { children: "In-depth" })), _jsx(InstrumentPanelTitle, { panel: panel })] })), secondaryButton: panel.exportable
                    ? {
                        icon: 'download',
                        tooltipContent: 'Export',
                        onClick: handleExport,
                    }
                    : undefined, onClose: onClose }), _jsx(ModalBody, Object.assign({ className: styles.modalBody }, { children: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(InstrumentRendererError, {}) }, { children: _jsx(InstrumentRenderer, { panel: panel, instruments: instruments, isFetching: isFetching, isError: isError, onReadInstruments: readInstruments, onSetInstrumentSettings: setInstrumentSettings }) })) }))] })));
};
